module.exports = __webpack_public_path__ + "img/featureCosme.001.144d0d72.jpeg";